import { render, staticRenderFns } from "./ProjectListItemSkeleton.vue?vue&type=template&id=044ca67c&scoped=true"
import script from "./ProjectListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./ProjectListItemSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ProjectListItemSkeleton.vue?vue&type=style&index=0&id=044ca67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ca67c",
  null
  
)

export default component.exports